import { Environment } from '@dice/app/types/env.type';
import { NgxLoggerLevel } from 'ngx-logger';

export const MOCK_ENV_CONFIG: Environment = {
  name: 'sc-mock',
  hostNames: ['localhost:5000'],
  enableDebugInfo: true,
  isProduction: false,
  publicStates: ['login'],
  apiEndpoint: `http://localhost:9090/api/`,
  wsEndpoint: `ws://localhost:9090/ws/`,
  wsEndpointForUCCP: `ws://localhost:9090/ws/`,
  agentViewEndpoint: `agent-view/`,
  agentViewStatisticsConsumerEndpoint: `agent-view-statistics/`,
  agentInfoStatisticsConsumerEndpoint: `buda-message-proxy-agentinfo/`,
  anomalyEndpoint: `dice-anomalies/api/anomalies/`,
  auditingEndpoint: `auditing/`,
  budaConfigurationEndpoint: `http://localhost:9090/api/`,
  budaStatisticsConsumerEndpoint: 'buda-statistics/',
  budaStatisticsConsumerEndpointForUCCP: 'buda-statistics/',
  configEndpoint: `dice-config/api/config/`,
  businessInsightsEndpoint: `business-insights/`,
  dataExchangeEndpoint: `data-exchange/`,
  diceUiRedirectPage: 'https://dice-ui.scapp-corp.swisscom.com/',
  eimaEndpoint: `eima/`,
  eimaDREndpoint: `eima-dr/`,
  notifications: `ws://localhost:9090/ws/notification/push-message-endpoint`,
  octEndpoint: `chat-campaign-tool/`,
  statisticsConsumerEndpoint: `http://localhost:8989/websocket`,
  transfertoolAdminURL: 'https://www.dev2.swisscom.ch/omni-transfertool-admin/login',
  userManagementEndpoint: `user-management/`,
  userManualURL: 'https://wiki.swisscom.com/pages/viewpage.action?pageId=617222684',
  logEndpoint: '',
  logLevel: NgxLoggerLevel.DEBUG,
  serverLogLevel: NgxLoggerLevel.OFF,
  variant: '',
  agentViewManualURL: 'https://wiki.swisscom.com/x/3yHdL',
  budaStatusURL: 'http://localhost:4200',
  cxGenesysModifierURL: 'http://localhost:9090/api/',
  apiProviderURL: 'http://localhost:9090/api-provider/',
};
